import { render, staticRenderFns } from "./wd-mv-layout-vertical-view.vue?vue&type=template&id=3273d2b4"
import script from "./wd-mv-layout-vertical-view.vue?vue&type=script&lang=js"
export * from "./wd-mv-layout-vertical-view.vue?vue&type=script&lang=js"
import style0 from "./wd-mv-layout-vertical-view.vue?vue&type=style&index=0&id=3273d2b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports